module.exports = __webpack_public_path__ + "static/media/butt09.8276d945.png";